export default class Packages {
    constructor() {
        this.tabs = $('.packages__tab')
        this.buttons = $('.packages__content .btn')
        this.scroller = $('.packages .btn--to-package')
        this.activeTab = false
        this.isPhone = false
    }

    /**
     * Close everything
     */
    closeAll() {
        $('.packages__tab').removeClass('is-open')
        $('.list__content').removeClass('is-open')
        $('.packages__category').hide()
    }

    /**
     * Handle clicking on tabs
     */
    handleTabClick(e) {
        e.preventDefault()
        let me = $(e.currentTarget)
        let id = me.data('tab')
        let tab = $(`.packages__tab[data-tab=${id}]`)
        let text = $(`#tab-${id}`)
        let list = $(`#list-content-${id}`)

        if (list.length) {
            if (!tab.hasClass('is-open')) {
                this.closeAll()

                tab.addClass('is-open')
                text.fadeIn(500)
                list.addClass('is-open')
                $('.packages').css('background-image', `url(${tab.data('image')})`)
                window.location.hash=id
                this.activeTab = true
            } else if (tab.hasClass('is-open') && this.activeTab && this.isPhone) {
                tab.data('has-text') ? this.scrollToText(text) : this.scrollToGrid()
            }
        }
    }

    /**
     * Handle clicking on grid-opening buttons
     */
    handleButtonClick(e) {
        let me = $(e.currentTarget)
        let grid = me.parents('.packages__category').find('.list__grid')

        if (grid.length) {
            grid.addClass('is-open')
        }
    }

    /**
     * Scroll down to products grid
     */
    scrollToGrid() {
        $('html, body').animate({ scrollTop: $('.list__content.is-open').offset().top - 130 }, 500)
    }

    /**
     * Scroll down to package text
     */
    scrollToText(element) {
        $('html, body').animate({ scrollTop: element.offset().top - 80 }, 500)
    }

    /**
     * Check for mobile devices (640px >)
     */
    checkPhone() {
        let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        let state = this.isPhone

        this.isPhone = w <= 640 ? true : false
    }

    /**
     * Initialize class
     */
    init() {
        var me = this;

        $(window).on('hashchange', function () {
            if (me.tabs.length) {
                me.tabs.off('click').on('click', e => me.handleTabClick(e))
                var hashId = window.location.hash.slice(1)

                this.activeTab = false
                if (hashId !== '') {
                    $(`.packages__tab[data-tab=${hashId}]`).click()
                } else {
                    $('.packages__tab').first().click()
                }
            }
        })

        $(window).on('resize', () => this.checkPhone())

        $(document).ready(function () {
            $(window).trigger("hashchange");
        });
        
        if (this.buttons.length) {
            this.buttons.on('click', e => this.handleButtonClick(e))
        }

        if (this.scroller.length) {
            this.scroller.on('click', () => this.scrollToGrid())
            this.checkPhone()
        }
    }
}
